var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCellProperityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 7.75,
    fill: "#FAFAFA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 7.75,
    stroke: "#E9E9E9",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.3125C7 7.13991 7.13991 7 7.3125 7H16.6875C16.8601 7 17 7.13991 17 7.3125V16.6875C17 16.8601 16.8601 17 16.6875 17H7.3125C7.13991 17 7 16.8601 7 16.6875V7.3125ZM7.625 7.625V11.6875H11.6875V7.625H7.625ZM12.3125 7.625V11.6875H16.375V7.625H12.3125ZM16.375 12.3125H12.3125V16.375H16.375V12.3125ZM11.6875 16.375V12.3125H7.625V16.375H11.6875Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09375 8.21875C8.09375 8.14971 8.14971 8.09375 8.21875 8.09375H11.0938C11.1628 8.09375 11.2188 8.14971 11.2188 8.21875V11.0938C11.2188 11.1628 11.1628 11.2188 11.0938 11.2188H8.21875C8.14971 11.2188 8.09375 11.1628 8.09375 11.0938V8.21875Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellProperityIcon);
export default __webpack_public_path__ + "static/media/cellProperityIcon.216ff3e55a2681621c83f14e8008e671.svg";
export { ForwardRef as ReactComponent };